import patientWaiterTableDataSource from "__mocks__/patientWaiterTable";
import {Row, Table, Typography} from "antd";
import {ColumnsType} from "antd/es/table";
import React, {useEffect, useState} from "react";
import "./PatientWaiter.scss";
import {medicalExaminationService} from "api";

const columns: ColumnsType = [
  {
    title: "STT",
    key: "stt",
    render: (v, r, idx) => <>{idx + 1}</>,
    align: "center",
  },
  {
    title: "Phòng khám",
    key: "tenPhong",
    dataIndex: "tenPhong",
    align: "center",
  },
  {
    title: "Số BN chờ",
    key: "soBenhNhanCho",
    dataIndex: "soBenhNhanCho",
    align: "right",
  },
  {
    title: "Tổng số",
    key: "tongSoBenhNhan",
    dataIndex: "tongSoBenhNhan",
    align: "right",
  },
];

const PatientWaiter = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [err, setErr] = useState<any>();

  useEffect(() => {
    const fetchData = async (params?: any) => {
      try {
        let response = await medicalExaminationService.getListPatientWaiter();
        setData(response.data);
        setLoading(false);
      } catch (error) {
        setErr(error.message);
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <Row className="patient-waiter-container">
      <Row>
        <Typography.Text strong>Số bệnh nhân chờ khám</Typography.Text>
      </Row>
      <Row>
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={false}
          bordered
        />
      </Row>
    </Row>
  );
};

export default PatientWaiter;
